import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ASSETS_CONSTANTS} from '../../../core/constants/assets.constants';
import {TBaseCommonComponent} from '../base-components/t-base-common.component';
import {CommonService} from '../../services/common.service';
import {ThemeService} from '../../services/theme.service';

@Component({
  standalone: true,
  selector: 'app-logo',
  imports: [],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent extends TBaseCommonComponent {
  constructor(
  ) {
    super();
  }

  @Input() showIcon: boolean = true;
  @Input() showText: boolean = true;
  @Input() clickable: boolean = false;

  @Output() logoClick = new EventEmitter<void>();

  onClick(): void {
    if (this.clickable) {
      this.logoClick.emit();
    }
  }
}
